import { getFunctions, httpsCallable } from 'firebase/functions';

// ─── TIER CONFIGURATION (mirrors backend) ───
export const TIER_CONFIG = {
  1: { name: 'Tier I', subName: 'Loki', max: 150000, upgradeCost: 0, roman: 'I', badge: '/Tiers/tier1_loki.png', gaugeMax: 100000 },
  2: { name: 'Tier II', subName: 'Thor', max: 350000, upgradeCost: 30000, roman: 'II', badge: '/Tiers/tier2_thor.png', gaugeMax: 300000 },
  3: { name: 'Tier III', subName: 'Odin', max: 800000, upgradeCost: 50000, roman: 'III', badge: '/Tiers/tier3_odin.png', gaugeMax: 700000 },
};

export const getTierExp = (user) => {
  if (!user) return 0;
  const tier = user.tier || 1;
  const currentPoints = user.points || 0;
  // Estimate total EXP if not explicitly tracked
  let spent = 0;
  if (tier > 1) spent += 30000;
  if (tier > 2) spent += 50000;
  const estimatedExp = currentPoints + spent;
  if (user.exp !== undefined) {
    return Math.max(user.exp, estimatedExp);
  }
  return estimatedExp;
};

/**
 * Get the tier progress as a percentage (0-100) for the gauge based on total earned.
 */
export const getTierProgress = (user) => {
  if (!user || typeof user === 'number') return 0; // Guard against legacy calls
  
  const tier = user.tier || 1;
  const totalEarned = getTierExp(user);

  const config = TIER_CONFIG[tier] || TIER_CONFIG[1];
  const target = config.gaugeMax || config.max;
  
  if (target === 0) return 100;
  return Math.min(100, Math.round((totalEarned / target) * 100));
};

/**
 * Get the next tier info (or null if at max).
 */
export const getNextTier = (currentTier) => {
  const next = currentTier + 1;
  return TIER_CONFIG[next] || null;
};

/**
 * Call the upgradeTier cloud function.
 */
export const upgradeTier = async () => {
  const functions = getFunctions();
  const fn = httpsCallable(functions, 'upgradeTier');
  const result = await fn();
  return result.data;
};

/**
 * Call the applyReferralCode cloud function.
 */
export const applyReferralCode = async (code) => {
  const functions = getFunctions();
  const fn = httpsCallable(functions, 'applyReferralCode');
  const result = await fn({ code });
  return result.data;
};

/**
 * Call the ensureReferralCode cloud function.
 * Generates one if the user doesn't have one yet.
 */
export const ensureReferralCode = async () => {
  const functions = getFunctions();
  const fn = httpsCallable(functions, 'ensureReferralCode');
  const result = await fn();
  return result.data;
};

/**
 * Generate a referral link for sharing.
 */
export const generateReferralLink = (code) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/?ref=${code}`;
};
